import React, {Component} from "react";
import cx from "classnames";
import style from "./Footer.module.scss";
import SocialLinks from "../../elements/SocialLinks/SocialLinks";
import {Link} from "gatsby";

export default class Footer extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    script.id = "Cookiebot";
    script.src = "https://consent.cookiebot.com/uc.js";
    script.async = true;
    script.setAttribute("data-cbid", "1606728e-16d6-4b6f-bbf2-8e8b2ef8de81");
    document.body.appendChild(script);
  }

  render() {
    let date = new Date();
    return (
      <footer className={style.footer}>
        <div className='container'>
          <div className={cx("row")}>
            <div className={style.main_row}>
              <div className={style.col1}>
                <div className={style.logo} />

                <div className={style.contact_info}>
                  <br></br>
                  <br></br>
                  <br></br>
                </div>
                <div className={style.phone}>info@e-leads.it</div>

                <div className='mt-3'>
                  <div className={style.column_title}>Ascolta la nostra playlist 🎶</div>

                  <iframe
                    src='https://open.spotify.com/embed/playlist/35RrIea6KIrqEuejzzAF1M?theme=0'
                    width='100%'
                    height='80'
                    frameBorder='0'
                    allowtransparency='true'
                    allow='encrypted-media'
                  ></iframe>
                </div>
              </div>
              <div className={style.col2}>
                <div className={style.column_title}>Servizi</div>
                <div className={style.column_links}>
                  <a href='/cosa-facciamo'>Cosa facciamo</a>
                  <a href='/assicurativo'>Piattaforma Assicurativa</a>
                </div>
              </div>
              <div className={style.col3}>
                <div className={style.column_title}>Su di noi</div>
                <div className={style.column_links}>
                  <a href='/chi-siamo'>Chi siamo</a>
                  <a href='/lavora-con-noi'>Lavora con noi</a>
                </div>
              </div>
              <div className={style.col4}>
                <div className={style.column_title}>Vieni a trovarci</div>
                <div className={cx("mb-4", style.column_links)}>
                  <p>
                    Via Gianbattista Bogino 9
                    <br />
                    10123 Torino
                  </p>
                </div>
                <SocialLinks />
                <div className={style.part_of}>E-leads fa parte di</div>
                <div className={style.logo_advice} />
              </div>
            </div>
          </div>
          <div className={cx("row", style.second_row)}>
            <div>© {date.getFullYear()} Tutti i diritti riservati</div>
            <div className={style.links}>
              <Link to='/Privacy-Policy-Sito-web'>Privacy Policy</Link> / <Link to='/company-info'>Company info</Link>
              {/*  / <Link to='/credits'>Credits</Link> */}
            </div>
          </div>
        </div>
        {/* 
    <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="1606728e-16d6-4b6f-bbf2-8e8b2ef8de81" type="text/javascript" async></script> */}
      </footer>
    );
  }
}
